import type { PermissionSelector } from "@/hooks/usePermission";

export const canManageRoles: PermissionSelector = (x) => x.userManagement.canManageRoles;
